/* eslint-disable */
export default function Loading({opacity}) {
    return (
        <div className={`w-[100vw] h-[100vh] flex justify-center items-center fixed top-0 left-0 z-[99999999] ${opacity ? `bg-black/${opacity}` : 'bg-white'}` }>
            <img src="/Loading.gif"></img>
        </div>
    )
}
